import React from 'react';
// import { Step } from 'react-joyride';

// Temporary types for React 19 compatibility
// TODO: Replace with types from a React 19 compatible tour library
interface Step {
  target: string;
  content: React.ReactNode;
  title?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  disableBeacon?: boolean;
}

export const overviewTourSteps = [
  {
    target: '[data-tour="valuation-methods-detail-table"]',
    content: (
      <div>
        <h3>Valuation Methods Detail Table</h3>
        <p>
          This table contains the valuation data that you can edit when in edit mode. Make your changes and remember to
          save them.
        </p>
      </div>
    ),
    placement: 'top' as const,
    disableBeacon: true,
  },
  {
    target: '[data-tour="waterfall-visibility-toggle"]',
    content: (
      <div>
        <h3>Visibility Toggle</h3>
        <p>
          This toggle controls whether company users can see sections. Click switch to hide or show sections from the
          client&apos;s view.
        </p>
      </div>
    ),
    placement: 'left' as const,
    disableBeacon: true,
  },
] as Step[];
